import { ShippingPlanMap } from "./SmbShipmentState.types";

export interface SmbShipmentState {
  shippingPlanMap: ShippingPlanMap;
}

export const smbShipmentInitialState: SmbShipmentState = {
  shippingPlanMap: {},
};
